import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { blogKeys } from "./keys";

export const useDeleteBlogArticle = () => {
	const mutation = useMutation({
		mutationFn: Api.Blog.deleteApiBlogById,
		mutationKey: blogKeys.delete,
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
